<template>
    <router-view />
</template>

<script>
export default {
    inject: ['reload'],
    data() {
        return {}
    },
    created() {
        this.$nextTick(() => {
            if (this.$route.path === '/learn') {
                this.$router.replace({
                    path: '/learn/exercise'
                })
            }
        })
    },
    mounted() {
        this.$nextTick(() => {})
    },
    methods: {}
}
</script>

<style scoped lang="less"></style>
